import { ReactNode } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/styles/createStyles';
import { Theme } from '@material-ui/core/styles';

export interface LabelProps {
    children: ReactNode;
    isPrimary?: true;
    isBold?: true;
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => unknown;
}

export const labelStyles = makeStyles((theme: Theme) =>
    createStyles({
        primary: {
            color: theme.palette.primary.main,
        },
        bold: {
            fontWeight: 'bold',
        },
        label24Styles: {
            fontSize: '24px',
            lineHeight: '26px',
        },
        label18Styles: {
            color: '#73717F',
            fontSize: '18px',
            letterSpacing: 0,
            lineHeight: '22px',
        },
        label16Styles: {
            fontSize: '16px',
            lineHeight: '22px',
        },
        label14Styles: {
            fontSize: '14px',
            lineHeight: '16px',
        },
    }),
);
